export const CONTENT_WINDOW_GAP = 20;
export const CONTENT_WINDOW_DEFAULT_WIDTH = 500;
export const CONTENT_WINDOW_DEFAULT_HEIGHT = 300;

// Единственный источник истины по числу одновременно открытых окон: его соблюдает
// и редьюсер при добавлении, и санитайзер при восстановлении сохранённого layout'а.
// Две разъезжающиеся тройки означали бы, что restore способен нарушить инвариант.
export const WINDOW_AMOUNT_LIMIT = 3;
